import { render, staticRenderFns } from "./IndexTable.vue?vue&type=template&id=1a99a42a&scoped=true"
import script from "./IndexTable.vue?vue&type=script&lang=js"
export * from "./IndexTable.vue?vue&type=script&lang=js"
import style0 from "./IndexTable.vue?vue&type=style&index=0&id=1a99a42a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a99a42a",
  null
  
)

export default component.exports